<template>
  <div class="swiper">
    <swiper
      :options="swiperOption"
      ref="bannerSwiper"
      @someSwiperEvent="callback"
      class="swiper-container"
    >
      <!-- 动态轮播图 -->
      <swiper-slide v-for="slide in currentBannerSlides" :key="slide.id">
        <a href="javascript:;">
          <!-- 产品类型轮播图 -->
          <div v-if="slide.type === 'product'" class="banner-bg">
            <div class="banner-content">
              <div class="banner-text">
                <h3 class="banner-title" v-html="getI18nTitle(slide)"></h3>
                <p class="banner-intro wrap-text color-o" v-html="getI18nIntro(slide)"></p>
                <p class="brief-explain wrap-text m-top" v-html="getI18nExplain(slide)"></p>
                <div>
                  <!-- <button class="more-btn font-w600">Learn more</button> -->
                </div>
              </div>
              <div class="banner-product">
                <img :src="getProductImagePath(slide.image)" :alt="getI18nTitle(slide)" />
              </div>
            </div>
          </div>
          
          <!-- 品牌类型轮播图 -->
          <div v-else-if="slide.type === 'brand'" 
               class="banner-bg-brand"
               :style="getBrandBackgroundStyle(slide.backgroundImage)">
          </div>
        </a>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination"></div>
    <!-- 分页 -->
  </div>
</template>

<script>
import { bannerMixin } from "@/mixins/bannerMixin.js";

export default {
  name: "carrousel",
  mixins: [bannerMixin],
  methods: {
    callback() {},
    
    // 国际化标题获取
    getI18nTitle(slide) {
      const i18nMap = {
        'common-0': 'bannerCommon.title',
        'common-1': 'bannerOne.title',
        'common-2': 'bannerTwo.title',
        'common-3': 'bannerThree.title',
        'common-4': 'bannerFour.title',
        'common-5': 'bannerFive.title',
        'common-6': 'bannerSix.title'
      };
      
      const i18nKey = i18nMap[slide.id];
      return i18nKey ? this.$t(i18nKey) : slide.title;
    },
    
    // 国际化介绍获取
    getI18nIntro(slide) {
      const i18nMap = {
        'common-0': 'bannerCommon.introduce',
        'common-1': 'bannerOne.introduce',
        'common-2': 'bannerTwo.introduce',
        'common-3': 'bannerThree.introduce',
        'common-4': 'bannerFour.introduce',
        'common-5': 'bannerFive.introduce',
        'common-6': 'bannerSix.introduce'
      };
      
      const i18nKey = i18nMap[slide.id];
      return i18nKey ? this.$t(i18nKey) : slide.intro;
    },
    
    // 国际化说明获取
    getI18nExplain(slide) {
      const i18nMap = {
        'common-0': 'bannerCommon.explain1',
        'common-1': 'bannerOne.explain1',
        'common-2': 'bannerTwo.explain1',
        'common-3': 'bannerThree.explain1',
        'common-4': 'bannerFour.explain1',
        'common-5': 'bannerFive.explain1',
        'common-6': 'bannerSix.explain1'
      };
      
      const i18nKey = i18nMap[slide.id];
      return i18nKey ? this.$t(i18nKey) : slide.explain;
    }
  }
};
</script>

<style></style>

<!-- banner原内容备份 -->
<!-- <div class="banner-content">
	<div class="banner-text">
		<h3 class="banner-title">Intelligent voice mouse • V8</h3>
		<p class="banner-intro wrap-text color-grey">You can type 400 words a minute</p>
		<p class="brief-explain wrap-text">vocie typing | 100+global languages | 24 dialects</p>
		<div>
			<button class="more-btn font-w600">Learn more</button>
		</div>
	</div>
	<div class="banner-product">
		<img src="../../assets/images/ai-img-mouse.png" />
	</div>
</div> -->
